import * as React from "react";
import CustomerServiceIcon from "./customer-service.png"

function SvgComponent(props) {
  return (
    <div>
    <img src={CustomerServiceIcon} alt="Customer Service" style={{ width: 40, height: 40 }} />
  </div>
  );
}

export default SvgComponent;
